<script setup lang="ts">
import { computed } from 'vue';
import { Menu } from '~/types';

interface Props {
  item: Menu.MenuItem;
  level?: number;
}
const props = withDefaults(defineProps<Props>(), { level: 0 });

const columnCustomClass = computed(() => props.item.data?.custom_class || {});
const levelCssClass = computed<string>(() => `column-menu-item--level-${props.level}`);
</script>

<template>
  <li :class="[columnCustomClass, levelCssClass]" class="column-menu-item">
    <ul class="column-menu-item__list">
      <template v-for="childrenMenuItem in item.children">
        <component
          :is="childrenMenuItem.component"
          v-if="childrenMenuItem?.component"
          :key="childrenMenuItem.id"
          :item="childrenMenuItem"
          :level="level"
        />
      </template>
    </ul>
  </li>
</template>

<style lang="scss" scoped>
.column-menu-item {
  &__list {
    @apply flex flex-col gap-3;
  }
}
</style>
